var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('h2',{staticClass:"subtitle-text"},[_vm._v(_vm._s(_vm.subtitleName))])])}
var staticRenderFns = []

export { render, staticRenderFns }